import { configureStore } from '@reduxjs/toolkit';
import calculatorReducer from './reducers/calculatorReducer';
import projectReducer from './reducers/projectReducer';
export var store = configureStore({ reducer: { calculator: calculatorReducer, projects: projectReducer } }); // Infer the `RootState` and `AppDispatch` types from the store itself
